const ___token = null;
const ___user = 'public';
const ___notification = null;
const ___location = 'client';

const ___dark_mode = {
	name : 'dark',
	background: '#26262',
	cl_000 : '#eee',
	cl_00 : '#ddd',
	cl_0 : '#ccc'
}

const ___light_mode = {
	name : 'light',
	background: '#fff',
	cl_000 : '#444',
	cl_00 : '#666',
	cl_0 : '#888'
}

export {
	___token,
	___user,
	___notification,
	___location,
    ___dark_mode,
    ___light_mode
}